import 'lib-flexible'
import Vant from 'vant'
import 'vant/lib/index.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 过滤器
import filters from './utils/filter'
// 公共方法
import './utils/utils'
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));
Vue.use(Vant);

Vue.config.productionTip = false;
Vue.prototype.$store = store;

// localStorage.setItem('userInfo','{"sex":null,"nickName":"王佳","age":null,"email":null,"phone":null,"portrait":"https://t.me/i/userpic/320/wangjia940509.jpg","status":1,"credits":30000000,"costCredits":2000,"_id":"5cee31780bc0dd3b352d8541","tgId":"854060012","createDate":"2019-05-15T04:18:29.981Z","name":"wangjia","updateDate":"2019-05-15T04:18:29.981Z"}')
//  localStorage.setItem('userInfo','{"sex":null,"nickName":"张伟","age":null,"email":null,"phone":null,"portrait":"https://t.me/i/userpic/320/zw940509.jpg","status":1,"credits":30000000,"costCredits":2000,"_id":"5cdb9315040a5231110221bf","tgId":"854060012","createDate":"2019-05-15T04:18:29.981Z","name":"wangjia","updateDate":"2019-05-15T04:18:29.981Z"}')
//  localStorage.setItem('userInfo','{"sex":null,"nickName":"图柏林","age":null,"email":null,"phone":null,"portrait":"https://t.me/i/userpic/320/tuboling168.jpg","status":1,"credits":30000000,"costCredits":2000,"_id":"5cef9247d3d4e05c39b05155","tgId":"854060012","createDate":"2019-05-15T04:18:29.981Z","name":"wangjia","updateDate":"2019-05-15T04:18:29.981Z"}')

const vue  = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

export default vue
